export const CONTENT_KEYS = ['articles', 'animations', 'models'];

export const CONTENT_CONFIG = {
  articles: {
    key: 'articles',
    title: 'Articles',
    singular: 'Article',
    route: '/articles',
    dashboardRoute: '/dashboard/articles',
    description:
      'Long-form content with body text, supporting media, tags, and language.',
  },
  animations: {
    key: 'animations',
    title: 'Gallery',
    singular: 'Gallery Item',
    route: '/gallery',
    dashboardRoute: '/dashboard/gallery',
    description:
      'Participant-created media entries with preview assets and downloadable files.',
  },
  models: {
    key: 'models',
    title: 'Course Content',
    singular: 'Course Module',
    route: '/course-content',
    dashboardRoute: '/dashboard/course-content',
    description:
      'Course lessons and supporting resources that replace the external Udemy flow.',
  },
};

export function getContentConfig(collectionKey) {
  return CONTENT_CONFIG[collectionKey] ?? null;
}

export function getEmptyContent(collectionKey) {
  const base = {
    title: '',
    slug: '',
    summary: '',
    tags: '',
    status: 'draft',
  };

  if (collectionKey === 'articles') {
    return {
      ...base,
      authorCreatorId: '',
      author: 'No Author',
      topic: '',
      articleLanguage: 'en',
      body: '',
      articleSections: [],
      articleReferences: [],
      articleFootnotes: [],
    };
  }

  if (collectionKey === 'animations') {
    return {
      ...base,
      description: '',
      topic: '',
      creatorName: '',
      creatorDiscipline: '',
      creatorStatement: '',
      mediaType: '',
    };
  }

  if (collectionKey === 'models') {
    return {
      ...base,
      description: '',
      type: '',
      sortOrder: '',
      metadata: '',
    };
  }

  return base;
}

export function summarizeContent(item, collectionKey) {
  if (collectionKey === 'articles') {
    return item.summary || item.sub_headline || item.topic || '';
  }

  if (collectionKey === 'animations') {
    return item.summary || item.description || item.topic || '';
  }

  if (collectionKey === 'models') {
    return item.summary || item.description || item.type || '';
  }

  return '';
}
